import React, { useState } from "react";
import { GenericInfoPopup, Icon, IconName, useDeviceTypes } from "halifax";
import { RouteComponentProps } from "react-router";
import clsx from "clsx";
import {
  ModalButtonType,
  ModalCategoryType,
  ModalScreens,
  MODAL_ALERT,
} from "redmond";
import { PATH_HOME } from "../../../../utils/paths";
import { ShopErrorModalConnectorProps } from "./container";
import * as textConstants from "./textConstants";
import "./styles.scss";
import { trackEvent } from "../../../../api/v0/analytics/trackEvent";
import { goToAvailability } from "../../utils/queryStringHelpers";

export interface IAvailabilityErrorModalProps
  extends ShopErrorModalConnectorProps,
    RouteComponentProps {}

export const ShopErrorModal = (props: IAvailabilityErrorModalProps) => {
  const {
    hasFailed,
    history,
    fetchPremierCollectionShop,
    missingRoomProductInfo,
    isMissingPayNowRates,
    fromDate,
    untilDate,
    adultsCount,
    childrenCount,
    lodging,
  } = props;
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const { matchesMobile } = useDeviceTypes();

  const getErrorTitle = () => {
    switch (true) {
      case missingRoomProductInfo:
        return textConstants.SHOP_MISSING_ROOMS_ERROR;
      case isMissingPayNowRates:
        return textConstants.SHOP_MISSING_PAY_NOW_RATES_TITLE;
      default:
        return textConstants.SHOP_ERROR_TITLE;
    }
  };

  const getErrorSubtitle = () => {
    switch (true) {
      case missingRoomProductInfo:
        return "";
      case isMissingPayNowRates:
        return textConstants.SHOP_MISSING_PAY_NOW_RATES_SUBTITLE;
      default:
        return textConstants.SHOP_ERROR_SUBTITLE;
    }
  };

  const modalEventProperties = {
    type: "pc_shop_error",
    primary_button: textConstants.SEARCH_AGAIN_BUTTON,
    secondary_button: textConstants.GO_BACK_BUTTON,
    screen: ModalScreens.HOTELS_SHOP,
    category: ModalCategoryType.TROUBLE,
    modal_subtitle: getErrorSubtitle(),
    modal_title: getErrorTitle(),
    lodging_id: lodging?.lodging.id,
    lodging_name: lodging?.lodging.name,
  };
  React.useEffect(() => {
    if (hasFailed) {
      setIsOpen(true);
      trackEvent({
        eventName: MODAL_ALERT,
        properties: { ...modalEventProperties },
      });
    }
  }, [hasFailed]);

  const buttons = [
    {
      buttonText: textConstants.GO_BACK_BUTTON,
      buttonWrapperClassName: clsx(
        "availability-error-modal-button",
        "secondary"
      ),
      onClick: () => {
        setIsOpen(false);
        trackEvent({
          eventName: MODAL_ALERT,
          properties: {
            ...modalEventProperties,
            button_choice: ModalButtonType.SECONDARY,
          },
        });
        if (isMissingPayNowRates) {
          if (matchesMobile) {
            history.goBack();
          } else {
            goToAvailability({
              history,
              lodging,
              fromDate,
              untilDate,
              adultsCount,
              childrenCount,
              isShopDetails: false,
            });
          }
        } else if (missingRoomProductInfo) {
          history.push(PATH_HOME);
        }
      },
    },
    ...(!isMissingPayNowRates
      ? [
          {
            buttonText: textConstants.SEARCH_AGAIN_BUTTON,
            buttonWrapperClassName: clsx(
              "availability-error-modal-button",
              "primary"
            ),
            onClick: () => {
              setIsOpen(false);
              trackEvent({
                eventName: MODAL_ALERT,
                properties: {
                  ...modalEventProperties,
                  button_choice: ModalButtonType.SECONDARY,
                },
              });
              fetchPremierCollectionShop(history, {});
            },
          },
        ]
      : []),
  ];

  return (
    <GenericInfoPopup
      className="hotel-shop-error-modal-root"
      open={isOpen}
      image={<Icon className="error-icon" name={IconName.ErrorState} />}
      title={getErrorTitle()}
      subtitle={getErrorSubtitle()}
      buttons={buttons}
      isMobile={matchesMobile}
    />
  );
};
